export default "__VITE_ASSET__D6JR7uDR__"